module.exports = __webpack_public_path__ + "static/solomon_toyota-c3959cc68376f8541588ab1998eaffc2.jpg";